import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { Landing } from './pages/Landing/Landing';
import { Modules } from './pages/Modules/Modules';
import { Pricing } from './pages/Pricing/Pricing';
import { AIStudio } from './pages/AIStudio/AIStudio';
import { About } from './pages/About/About';
import { Contact } from './pages/Contact/Contact';
import { Settings } from './pages/Settings/Settings';

export const AppRoutes: React.FC = () => {
  return (
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route exact path="/modules" component={Modules} />
      <Route exact path="/pricing" component={Pricing} />
      <Route exact path="/ai-studio" component={AIStudio} />
      <Route exact path="/about" component={About} />
      <Route exact path="/contact" component={Contact} />
      <Route exact path="/settings" component={Settings} />
      <Redirect to="/" />
    </Switch>
  );
};
